import React, {Fragment} from 'react'
import { graphql, StaticQuery, navigate, Link } from 'gatsby'
import {Elements, StripeProvider} from 'react-stripe-elements';
import PaymentForm from './PaymentForm';
import Spinner from '../Spinner'
import Fab from '@material-ui/core/Fab';
import moment from 'moment'
import { connect } from "react-redux"
import {checkEmail, checkEmailPremium, validateEmailDomain} from '../../utils/Helper'
import {fieldErrors} from '../../utils/errors'
import Lock from '../../assets/lock.svg'
import GrayArrow from '../../assets/gray_arrow.svg'
import { logEvent, pushToDataLayer } from '../Analytics'

class Quiz extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            step : 0,
            contentNo: 0,
            contentType: '',
            loading: false,
            email: '',
            termCondition: false,
            emailDomainError: ''
        }
    }

    handleInput = (e) => {
        this.setState({email: e.target.value, emailDomainError: ''})
        
		if(validateEmailDomain(e.target.value)){
            this.setState({email: e.target.value, emailDomainError: fieldErrors.emailDomain})
		}
    }

    handleClick = (e) => {
        this.setState({termCondition: e.target.checked})
    }

    gotoStep = (step, page, type) => {
        this.setState({step: step, contentNo: page})

        if(typeof type !== 'undefined'){
            this.setState({contentType: type})
        }
    }

    back = (step) => {
        this.setState({step: step})
    }

    validate = () => {
        const { email, termCondition } = this.state;
        const { dispatchCheckboxError, dispatchEmailError, dispatchStripeError, dispatchGenerateToken, dispatchDisabledButton, dispatchSubmitFrom } = this.props;
        
        dispatchCheckboxError('') 
        dispatchEmailError('')

        if (email.length === 0) return dispatchEmailError(fieldErrors.emailEmpty)
        if (!checkEmail(email)) return dispatchEmailError(fieldErrors.invalidEmail)
        if (!termCondition) return dispatchCheckboxError(fieldErrors.terms)
        
        dispatchStripeError('');
        dispatchDisabledButton(true)
        dispatchSubmitFrom(true)

        checkEmailPremium(email, (resp) => {
            if(!resp){
                dispatchDisabledButton(true)
                dispatchSubmitFrom(true)
                dispatchGenerateToken(true);
			}else{
				dispatchEmailError(fieldErrors.userAlreadyPremium);
                dispatchDisabledButton(false)
                dispatchSubmitFrom(false)
            }
        })
    }

    registerSeniorUser = () => {
        pushToDataLayer('addtocart_edimia', 'Cart', 'AddToCart', 'Edimia');
        
        const { token, dispatchStripeError, dispatchDisabledButton, dispatchSubmitFrom, dispatchSetToken } = this.props;
        const { email } = this.state;

        
            const formState = {
                token: token,
                plan: 'junior',
                email: email,
                location: "SE",
                campaign: 'common',
                trail: 30,
                origin: typeof window !== 'undefined' ? window.location.href : ''
            }

            dispatchSetToken('')

            fetch(`${process.env.API_URI}/users/create`, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(formState)
            })
            .then(resp => resp.json())
            .then(resp => {
                console.log('resp', resp)
                if (resp.status === 200) {
                    pushToDataLayer('addtocart_edimia', 'Purchase', 'done', 'Edimia');
                    navigate(
                        '/congrats',
                        { state: {email, plan: 'junior', userId: resp.userId, campaign: 'common'} }
                    )
                } else {
                    dispatchStripeError(resp.errorMsg)
                    dispatchDisabledButton(false)
                    dispatchSubmitFrom(false)
                }
            })
            .catch(error => console.error(error))
        
    }

    render(){
        const { step, contentNo, contentType, email, emailDomainError } = this.state;
        const { token, buttonDisabled, submitForm, stripeError, juniorEmailError, juniorCheckboxError,
            dispatchDisabledButton, dispatchSubmitFrom} = this.props;

        if(token !== ''){
            this.registerSeniorUser()
        }

        if(stripeError !== ''){
            dispatchDisabledButton(false)
            dispatchSubmitFrom(false)
        }

        const title = ['Berätta vad ni vill ha hjälp med!', 'Tycker ni matte är...'];
        const content = {
            roligt_0 : {
                title: 'Jag lär dig grunderna på nolltid!',
                subTitle: 'Med mig får du tillgång till tusentals pedagogiska övningar speciellt framtagna för att barn ska förstå matematik enklare. Allt är framtaget av erfarna pedagoger, lärare och forskare.',
                list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: 'Testa gratis idag!',
                note1: '(Ordinarie pris 99kr/månad)'
            },            
            roligt_1 : {
                title: 'Wohoo, du har hamnat rätt!',
                subTitle: 'Hos mig hittar du tusentals roliga övningar som anpassats efter din årskurs - nu kör vi!',
                list: [' Kopplad till läroplanen',  ' Tusentals roliga övningar', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: 'Testa gratis idag!',                 note1: '(Ordinarie pris 99kr/månad)'
            },
            
            roligt_2 : {
                title: 'Övning ger färdighet!',
                subTitle: 'Tillsammans ska vi se till att du blir en sann mattemästare. Du kan öva på matten för din årskurs eller gå upp och läsa mer avancerade nivåer - du bestämmer och jag hjälper dig hela vägen!',
                list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: 'Testa gratis idag!',                 note1: '(Ordinarie pris 99kr/månad)'
            },
            
            mest_0 : {
                title: 'Känn ingen press, vi löser det tillsammans.',
                subTitle: 'Välj i lugn och ro bland massor med övningar. Samtliga har tagits fram av pedagoger, lärare och forskare för att göra matten roligare och mer engagerande. Plugga med mig tio minuter om dagen så kommer det gå fint!',
                list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: 'Testa gratis idag!',                 note1: '(Ordinarie pris 99kr/månad)'
            },

            mest_1 : {
                title: 'Välj bland tusentals roliga övningar!',
                subTitle: 'Alla mina övningar har tagits fram av erfarna pedagoger, lärare och forskare - allt för att matten ska bli så kul som möjligt! Testa dig fram bland alla tusentals övningar, i din takt - när du vill!',
                list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: ''
            },

            mest_2 : {
                title: 'Känn ingen press.',
                subTitle: 'Att förstå matte kan vara svårt, men jag finns här för att hjälpa dig hela vägen. Med övning och tålamod kommer du nå målet - garanterat! Öva i minst 10 minuter om dagen så blir du en mattemästare innan du vet ordet av!',
                list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: 'Testa gratis idag!',                 note1: '(Ordinarie pris 99kr/månad)'
            }

            
        }

        return(
            <section className="cvd-tips">
                     <div className="custom-container">
                            <div className="tips-box">
                                <h2>Tips inför hemundervisning</h2>
                                <ol>
                                    <li>Sitt i en bra studiemiljö</li>
                                    <li>Planera in studietiden</li>
                                    <li>Ta pauser och rör på dig</li>
                                    <li>Undvik distraktioner</li>
                                    <li>Tänk högt för dig själv</li>
                                </ol>
                            </div>
                     </div>
                </section>
       )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.juniorToken,
        submitForm: state.juniorFormSubmit,
        stripeError: state.juniorStripeError,
        buttonDisabled: state.buttonDisabled,
        juniorEmailError: state.juniorEmailError,
        juniorCheckboxError: state.juniorCheckboxError
    }
}
  
const mapDispatchToProps = dispatch => {
    return { 
        dispatchSetToken: (token) => dispatch({ type: `JUNIOR_TOKEN`, value: token }),
        dispatchSubmitFrom: (status) => dispatch({ type: `JUNIOR_FORM_SUBMIT`, value: status }),
        dispatchStripeError: (error) => dispatch({ type: `JUNIOR_STRIPE_ERROR`, value: error }),
        dispatchGenerateToken: (status) => dispatch({ type: `JUNIOR_GENERATE_TOKEN`, value: status }),
        dispatchDisabledButton: (status) => dispatch({ type: `DISABLED_BUTTON`, value: status }),
        dispatchEmailError: (status) => dispatch({ type: `JUNIOR_EMAIL_ERROR`, value: status }),
        dispatchCheckboxError: (status) => dispatch({ type: `JUNIOR_CHECKBOX_ERROR`, value: status }),
    }
}
  
const QuizClass = connect(mapStateToProps, mapDispatchToProps)(Quiz)

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    iPhone: file(relativePath: {regex: "/iphone-mob/"}) {
                        publicURL
                    }                    
                }`
            }
        render={(data)  => (
           <QuizClass query={data} {...props}/>
        )}
    />
)